import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search_s",
  "use": "search_s-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"search_s\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.122 9.143l3.673 3.66A.701.701 0 0113.296 14a.703.703 0 01-.497-.204L9.12 10.128a5.648 5.648 0 01-3.45 1.178C2.543 11.306 0 8.77 0 5.653 0 2.536 2.544 0 5.67 0c3.127 0 5.67 2.536 5.67 5.653a5.61 5.61 0 01-1.218 3.49zm-4.45-7.74c-2.351 0-4.265 1.906-4.265 4.25 0 2.343 1.914 4.25 4.264 4.25 2.351 0 4.264-1.907 4.264-4.25 0-2.344-1.913-4.25-4.264-4.25z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol